import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { serviceCallData, serviceExportData, serviceInclinicData, serviceMessageData, serviceSuperviewActiveUserCount, serviceUserOnboardingData } from "../../../Services/Service";
import LoadingComponent from "../../components/LoadingComponent";

export default (({ filterForm, title,onClose, ...props }) => {
    const { startRange,
        endRange,
        divisionClinicFilter,
        programSelect } = filterForm;

    const [loading, setLoading] = useState(false);

    const [modalTitle, setModalTitle] = useState("");
    const [modalContent, setModalContent] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const [loadingExport, setLoadingExport] = useState(false);
    const [paginatedContent, setPaginatedContent] = useState([]);

    const [activeUserDetails, setActiveUserDetails] = useState([]);
    const [activeUserDetails1, setActiveUserDetails1] = useState([]);

    const [showExportButton, setShowExportButton] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);

    const itemsPerPage = 5; // Number of rows per page
    const totalPages = Math.ceil(modalContent.length / itemsPerPage);


    useEffect(() => {
        setLoading(true)
        setModalTitle(title);
        updateModalTitle(title);
    }, [title])

    useEffect(() => {         
        if (modalContent && modalContent.length > 0) {
            const updatedPaginatedContent = modalContent.slice(
                (currentPage - 1) * itemsPerPage,
                currentPage * itemsPerPage
            );
            setPaginatedContent(updatedPaginatedContent);
        } else {
            setPaginatedContent([]);
        }
        //  setLoading(false)
    }, [modalContent, currentPage]);
    
    const handleModalClose = () => {
        setCurrentPage(1); // Reset pagination to the first page
        // Add other close logic if necessary, such as hiding the modal
        onClose && onClose('');
    };

    const updateModalTitle = async (title) => {
        // console.log(title, "title")
        if (loading) {
            return;
        }
        setLoading(true);
        try {
            setModalContent([]);
            setCsvData([]);
            setModalTitle(title);
            if (title == "Active Patients") {
                await serviceSuperviewActiveUserCount(
                    startRange,
                    endRange,
                    divisionClinicFilter,
                    programSelect,
                    "Y"
                ).then((res) => {
                    setModalContent(res.data.data);
                    setActiveUserDetails1(res.data.data)
                });
            } else if (
                title == "Messages from Coach to Patient" ||
                title == "Messages from Patient to Coach"
            ) {
                let selection =
                    title == "Messages from Coach to Patient"
                        ? "coachPatient"
                        : "patientCoach";
                await serviceMessageData(
                    startRange,
                    endRange,
                    selection,
                    divisionClinicFilter,
                    programSelect
                ).then((res) => {
                    // console.log(res.data.data, "reached")
                    setModalContent(res.data.data);
                });
            } else if (
                title == "Scheduled Calls" ||
                title == "Completed Calls" ||
                title == "Incomplete Calls" ||
                title == "Missed Calls" ||
                title == "Cancelled Calls" ||
                title == "Unsuccessful Calls"
            ) {
                let selection = title;
                await serviceCallData(
                    startRange,
                    endRange,
                    selection,
                    divisionClinicFilter,
                    programSelect
                ).then((res) => {
                    // console.log(res.data.data, "reached")
                    setModalContent(res.data.data);
                });
            } else if (
                title == "Partially Registered Patients" ||
                title == "Fully Onboarded Patients" ||
                title == "Accounts Created" ||
                title == "In-Active Patients"||
                title =="Opt-Out Patients"
            ) {
                let selection = title;
                await serviceUserOnboardingData(
                    startRange,
                    endRange,
                    selection,
                    divisionClinicFilter,
                    programSelect
                ).then((res) => {
                    // console.log(res.data.data, "reached")
                    setModalContent(res.data.data);
                });
            } else if (
                title == "Scheduled In-Clinic Appointments" ||
                title == "Completed In-Clinic Appointments"
            ) {
                let selection = title;
                await serviceInclinicData(
                    startRange,
                    endRange,
                    selection,
                    divisionClinicFilter,
                    programSelect
                ).then((res) => {
                    // console.log(res.data.data, "reached")
                    setModalContent(res.data.data);
                });
            }
            setShowExportButton(true);
        } catch (e) {
            console.log(e.message);
        } finally {
            setLoading(false)
        }

    };

    const handleNext = () => {
        // console.log(currentPage, "currentPage")
        // console.log(totalPages, "totalPages")
        if (currentPage < totalPages) {
            setCurrentPage((prevPage) => prevPage + 1);
        }
    };
    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage((prevPage) => prevPage - 1);
        }
    };
    const fetchExportData = async () => {
        try {
            //alert("HEREE");
            setLoadingExport(true);
            setCsvData([]);
            //alert("cec");
            // Set the selection based on modalTitle
            const selection = modalTitle;

            //alert(modalTitle);
    
            // Call the service to fetch export data
            const response = await serviceExportData(
                filterForm?.startRange,
                filterForm?.endRange,
                selection,
                filterForm?.divisionClinicFilter,
                filterForm?.programSelect
            );

            // Extract the relevant data from the API response
            const data = response?.data?.data || [];
            // console.log(data, "data")
            // console.log(modalTitle, "modalTitle")
            // Process and transform the data for export
            console.log("activeUserDetails", activeUserDetails1);
            const exportData =
                modalTitle === "Active Patients"
                    ? activeUserDetails1.map((item) => ({
                        patient_name: item.patient_name,
                        NHS_Id: item.NHS_Id,
                        mobile: item.mobile,
                        program_names: item.program_names,
                        smssentdate:
                            !item.smssentdate ||
                                item.smssentdate === "0000-00-00 00:00:00" ||
                                isNaN(new Date(item.smssentdate).getTime())
                                ? "-"
                                : new Date(item.smssentdate).toLocaleDateString("en-GB"),
                        smsdeliverdate:
                            !item.smsdeliverdate ||
                                item.smsdeliverdate === "0000-00-00 00:00:00" ||
                                isNaN(new Date(item.smsdeliverdate).getTime())
                                ? "-"
                                : new Date(item.smsdeliverdate).toLocaleDateString("en-GB"),
                    }))
                    : (modalTitle === "Fully Onboarded Patients")
                        ? modalContent.map((item) => ({
                            patient_name: item.patient_name,
                            NHS_Id: item.nhsNumber,
                            mobile: item.mobile,
                            program_names: item.program_names,
                            smssentdate: new Date(item.smssentdate).toLocaleDateString(
                                "en-GB"
                            ),
                            smsdeliverdate: new Date(item.smsdeliverdate).toLocaleDateString(
                                "en-GB"
                            ),
                            loggedindate: new Date(item.loginDate).toLocaleDateString(
                                "en-GB"
                            ),
                            onboardingdate: new Date(item.onboarding_date).toLocaleDateString(
                                "en-GB"
                            ),
                        }))
                        : modalTitle === "Accounts Created"
                            ? modalContent.map((item) => ({
                                patient_name: item.patient_name,
                                NHS_Id: item.nhsNumber,
                                mobile: item.mobile,
                                program_names: item.program_names,
                                smssentdate:
                                    !item.smssentdate ||
                                        item.smssentdate === "0000-00-00 00:00:00" ||
                                        isNaN(new Date(item.smssentdate).getTime())
                                        ? "-"
                                        : new Date(item.smssentdate).toLocaleDateString("en-GB"),

                                smsdeliverdate:
                                    !item.smsdeliverdate ||
                                        item.smsdeliverdate === "0000-00-00 00:00:00" ||
                                        isNaN(new Date(item.smsdeliverdate).getTime())
                                        ? "-"
                                        : new Date(item.smsdeliverdate).toLocaleDateString("en-GB"),
                                onboardingdate:
                                    !item.onboarding_date ||
                                        item.onboarding_date === "0000-00-00 00:00:00" ||
                                        isNaN(new Date(item.onboarding_date).getTime())
                                        ? "-"
                                        : new Date(item.onboarding_date).toLocaleDateString("en-GB"),
                            }))
                            : (modalTitle === "In-Active Patients" || modalTitle=="Opt-Out Patients")
                                ? modalContent.map((item) => ({
                                    patient_name: item.patient_name,
                                    NHS_Id: item.nhsNumber,
                                    mobile: item.mobile,
                                    program_names: item.program_names,
                                    onboardingdate: new Date(item.onboarding_date).toLocaleDateString(
                                        "en-GB"
                                    ),
                                }))
                                : modalTitle === "Partially Registered Patients"
                                    ? modalContent.map((item) => ({
                                        patient_name: item.patient_name,
                                        NHS_Id: item.nhsNumber,
                                        mobile: item.mobile,
                                        program_names: item.program_names,
                                        smssentdate: new Date(item.smssentdate).toLocaleDateString(
                                            "en-GB"
                                        ),
                                        smsdeliverdate: new Date(item.smsdeliverdate).toLocaleDateString(
                                            "en-GB"
                                        ),
                                        loggedindate: new Date(item.loginDate).toLocaleDateString(
                                            "en-GB"
                                        ),
                                    }))
                                    : modalTitle === "Scheduled In-Clinic Appointments"
                                        ? data.map((item) => ({
                                            patient_name: item.patient_name,
                                            NHS_Id: item.nhsNumber,
                                            mobile: item.mobile,
                                            appointment_scheduled_on: new Date(
                                                item.appointment_scheduled_on
                                            ).toLocaleDateString("en-GB"),
                                            appointment_scheduled_on: new Date(
                                                item.appointment_scheduled_on
                                            ).toLocaleDateString("en-GB"),
                                            appointment_status: item.appointment_status,
                                            cnt: item.cnt,
                                        }))
                                        : modalTitle === "Completed In-Clinic Appointments"
                                            ? data.map((item) => ({
                                                patient_name: item.patient_name,
                                                NHS_Id: item.nhsNumber,
                                                mobile: item.mobile,
                                                appointment_scheduled_on: new Date(
                                                    item.appointment_scheduled_on
                                                ).toLocaleDateString("en-GB"),
                                                appointment_scheduled_on: new Date(
                                                    item.appointment_scheduled_on
                                                ).toLocaleDateString("en-GB"),
                                                appointment_status: item.appointment_status,
                                                appointment_completed_on: new Date(
                                                    item.appointment_completed_on
                                                ).toLocaleDateString("en-GB"),
                                                cnt: item.cnt,
                                            }))
                                            : modalTitle === "Messages from Patient to Coach"
                                                ? data.map((item) => ({
                                                    patient_name: item.patient_name,
                                                    NHS_Id: item.nhsNumber,
                                                    mobile: item.mobile,
                                                    coachname: item.coachname,
                                                    cnt: item.cnt,
                                                }))
                                                : modalTitle === "Messages from Coach to Patient"
                                                    ? data.map((item) => ({
                                                        patient_name: item.patient_name,
                                                        NHS_Id: item.nhsNumber,
                                                        mobile: item.mobile,
                                                        coachname: item.coachname,
                                                        cnt: item.cnt,
                                                    }))
                                                    : data.map((item) => ({
                                                        patient_name: item.patient_name,
                                                        NHS_Id: item.nhsNumber,
                                                        mobile: item.mobile,
                                                        total_conversations: item.cnt,
                                                    }));

            console.log(exportData, "exportData");

            setCsvData(exportData);
            setShowExportButton(false);
            // setTimeout(() => {
            //   document.getElementById("csv-link").click();
            // }, 1000);
            // document.getElementById("csv-link").click();
        } catch (error) {
            console.error("Error fetching export data:", error);
            return [];
        } finally {
            setLoadingExport(false);
        }
    };

      const headersMap = {
        "Active Patients": [
        { label: "Patient Name", key: "patient_name" },
        { label: "NHS ID", key: "NHS_Id" },
        { label: "Mobile Number", key: "mobile" },
        { label: "Program Name", key: "program_names" },
        { label: "SMS Sent Date", key: "smssentdate" },
        { label: "SMS Delivered Date", key: "smsdeliverdate" },
        ],
        "Fully Onboarded Patients": [
        { label: "Patient Name", key: "patient_name" },
        { label: "NHS ID", key: "NHS_Id" },
        { label: "Mobile Number", key: "mobile" },
        { label: "Program Name", key: "program_names" },
        { label: "Logged In Date", key: "loggedindate" },
        { label: "Onboarding Date", key: "onboardingdate" },
        ],
        "Partially Registered Patients": [
        { label: "Patient Name", key: "patient_name" },
        { label: "NHS ID", key: "NHS_Id" },
        { label: "Mobile Number", key: "mobile" },
        { label: "Program Name", key: "program_names" },
        { label: "Logged In Date", key: "loggedindate" },
        ],
        "Scheduled In-Clinic Appointments": [
        { label: "Patient Name", key: "patient_name" },
        // { label: "NHS ID", key: "NHS_Id" },
        // { label: "Mobile Number", key: "mobile" },
        { label: "Date Appointment Booked on", key: "appointment_scheduled_on" },
        { label: "Appointment Date", key: "appointment_scheduled_on" },
        { label: "Appointment Status", key: "appointment_status" },
        { label: "Count of calls", key: "cnt" },
        ],
        "Completed In-Clinic Appointments": [
        { label: "Patient Name", key: "patient_name" },
        // { label: "NHS ID", key: "NHS_Id" },
        // { label: "Mobile Number", key: "mobile" },
        { label: "Date Appointment Booked on", key: "appointment_scheduled_on" },
        { label: "Appointment Date", key: "appointment_scheduled_on" },
        { label: "Appointment Status", key: "appointment_status" },
        { label: "Date of Completion", key: "appointment_completed_on" },
        { label: "Count of calls", key: "cnt" },
        ],
        "Messages from Coach to Patient": [
        { label: "Patient Name", key: "patient_name" },
        { label: "NHS ID", key: "NHS_Id" },
        { label: "Coach Name", key: "coachname" },
        { label: "Mobile Number", key: "mobile" },
        { label: "Count of Coach messages", key: "cnt" },
        ],
        "Messages from Patient to Coach": [
        { label: "Patient Name", key: "patient_name" },
        { label: "NHS ID", key: "NHS_Id" },
        { label: "Coach Name", key: "coachname" },
        { label: "Mobile Number", key: "mobile" },
        { label: "Count of Patient messages", key: "cnt" },
        ],
        "In-Active Patients": [
        { label: "Patient Name", key: "patient_name" },
        { label: "NHS ID", key: "NHS_Id" },
        { label: "Mobile Number", key: "mobile" },
        { label: "Program Name", key: "program_names" },
        { label: "Onboarding Date", key: "onboardingdate" },
        ],
        "Accounts Created": [
        { label: "Patient Name", key: "patient_name" },
        { label: "NHS ID", key: "NHS_Id" },
        { label: "Mobile Number", key: "mobile" },
        { label: "Program Name", key: "program_names" },
        { label: "Onboarding Date", key: "onboardingdate" },
        { label: "SMS Sent Date", key: "smssentdate" },
        { label: "SMS Delivered Date", key: "smsdeliverdate" },
        ],
        default: [
        { label: "Patient Name", key: "patient_name" },
        { label: "NHS ID", key: "NHS_Id" },
        { label: "Mobile Number", key: "mobile" },
        { label: "Conversation Count", key: "total_conversations" },
        ],
    };
    const headers = headersMap[modalTitle] || headersMap.default;

    return <>
        <div
            className="modal fade"
            id="superAdminModal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-xl" style={{ maxWidth: "96%" }}>
                <div className="modal-content">
                    <div
                        className="modal-header"
                        style={{ paddingBottom: "0px", border: "none" }}
                    >
                        <h1 className="modal-title fs-5" id="modalTitle">
                            {modalTitle || "Modal title"}
                        </h1>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={handleModalClose}
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div>
                             <LoadingComponent className={`${!loading && 'd-none'}`}/>

                            <div className={`row ${loading && 'd-none'}`}>
                                <div className="col-md-12">
                                   
                                    <div className={`table-responsive`}>
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    {modalTitle && modalTitle === "Active Patients" ? (
                                                        <>
                                                            <th scope="col" className="text-start">
                                                                Patient Name
                                                            </th>
                                                            <th scope="col">NHS ID</th>
                                                            <th scope="col">Mobile Number</th>
                                                            <th scope="col">Program Name</th>
                                                            <th scope="col">SMS Sent Date</th>
                                                            <th scope="col">SMS Delivered Date</th>
                                                        </>
                                                    ) : modalTitle === "Fully Onboarded Patients" ? (
                                                        <>
                                                            <th scope="col" className="text-start">
                                                                Patient Name
                                                            </th>
                                                            <th scope="col">NHS ID</th>
                                                            <th scope="col">Mobile Number</th>
                                                            <th scope="col">Program Name</th>
                                                            <th scope="col">SMS Sent Date</th>
                                                            <th scope="col">SMS Delivered Date</th>
                                                            <th scope="col">Logged In Date</th>
                                                            <th scope="col">Onboarding Date</th>
                                                        </>
                                                    ) : modalTitle ===
                                                        "Partially Registered Patients" ? (
                                                        <>
                                                            <th scope="col" className="text-start">
                                                                Patient Name
                                                            </th>
                                                            <th scope="col">NHS ID</th>
                                                            <th scope="col">Mobile Number</th>
                                                            <th scope="col">Program Name</th>
                                                            <th scope="col">SMS Sent Date</th>
                                                            <th scope="col">SMS Delivered Date</th>
                                                            <th scope="col">Logged In Date</th>
                                                        </>
                                                    ) : modalTitle ===
                                                        "Scheduled In-Clinic Appointments" ? (
                                                        <>
                                                            <th scope="col" className="text-start">
                                                                Patient Name
                                                            </th>
                                                            {/* <th scope="col">NHS ID</th>
                                    <th scope="col">Mobile Number</th> */}
                                                            <th scope="col">Date Appointment Booked on</th>
                                                            <th scope="col">Appointment Date</th>
                                                            <th scope="col">Appointment Status</th>
                                                        </>
                                                    ) : modalTitle ===
                                                        "Completed In-Clinic Appointments" ? (
                                                        <>
                                                            <th scope="col" className="text-start">
                                                                Patient Name
                                                            </th>
                                                            {/* <th scope="col">NHS ID</th>
                                    <th scope="col">Mobile Number</th> */}
                                                            <th scope="col">Date Appointment Booked on</th>
                                                            <th scope="col">Appointment Date</th>
                                                            <th scope="col">Appointment Status</th>
                                                            <th scope="col">Date of Completion</th>
                                                        </>
                                                    ) : modalTitle === "Accounts Created" ? (
                                                        <>
                                                            <th scope="col" className="text-start">
                                                                Patient Name
                                                            </th>
                                                            <th scope="col">NHS ID</th>
                                                            <th scope="col">Mobile Number</th>
                                                            <th scope="col">Program Name</th>
                                                            <th scope="col">SMS Sent Date</th>
                                                            <th scope="col">SMS Delivered Date</th>
                                                        </>
                                                    ) : (modalTitle === "In-Active Patients"||modalTitle=="Opt-Out Patients") ? (
                                                        <>
                                                            <th scope="col" className="text-start">
                                                                Patient Name
                                                            </th>
                                                            <th scope="col">NHS ID</th>
                                                            <th scope="col">Mobile Number</th>
                                                            <th scope="col">Program Name</th>
                                                            <th scope="col">SMS Sent Date</th>
                                                            <th scope="col">SMS Delivered Date</th>
                                                            <th scope="col">Onboarding Date</th>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <th scope="col" className="text-start">
                                                                Year
                                                            </th>
                                                            <th scope="col">Month/Week/Date</th>
                                                            <th scope="col">Conversation Count</th>
                                                        </>
                                                    )}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {paginatedContent && paginatedContent.length > 0 ? (
                                                    paginatedContent.map((item, index) => {
                                                        const formattedSentDate =
                                                            item.smssentdate &&
                                                                item.smssentdate !== "0000-00-00 00:00:00"
                                                                ? new Date(
                                                                    item.smssentdate
                                                                ).toLocaleDateString("en-GB", {
                                                                    day: "2-digit",
                                                                    month: "2-digit",
                                                                    year: "numeric",
                                                                })
                                                                : "-";
                                                        const formattedDeliveredDate =
                                                            item.smsdeliverdate &&
                                                                item.smsdeliverdate !== "0000-00-00 00:00:00"
                                                                ? new Date(
                                                                    item.smsdeliverdate
                                                                ).toLocaleDateString("en-GB", {
                                                                    day: "2-digit",
                                                                    month: "2-digit",
                                                                    year: "numeric",
                                                                })
                                                                : "-";
                                                        const formattedOnboardingDate = new Date(
                                                            item.onboarding_date
                                                        ).toLocaleDateString("en-GB", {
                                                            day: "2-digit",
                                                            month: "2-digit",
                                                            year: "numeric",
                                                        });
                                                        const formattedLoginDate = new Date(
                                                            item.loginDate
                                                        ).toLocaleDateString("en-GB", {
                                                            day: "2-digit",
                                                            month: "2-digit",
                                                            year: "numeric",
                                                        });
                                                        const formattedScheduledDate = new Date(
                                                            item.appointment_scheduled_on
                                                        ).toLocaleDateString("en-GB", {
                                                            day: "2-digit",
                                                            month: "2-digit",
                                                            year: "numeric",
                                                        });
                                                        const formattedCompletedDate = new Date(
                                                            item.appointment_completed_on
                                                        ).toLocaleDateString("en-GB", {
                                                            day: "2-digit",
                                                            month: "2-digit",
                                                            year: "numeric",
                                                        });

                                                        return (
                                                            <>
                                                                {modalTitle &&
                                                                    modalTitle == "Active Patients" ? (
                                                                    <tr key={`one_${index}`}>
                                                                        <th
                                                                            scope="row"
                                                                            className="text-start ps-2"
                                                                        >
                                                                            {item.patient_name}
                                                                        </th>
                                                                        <td>{item.NHS_Id}</td>
                                                                        <td>{item.mobile}</td>
                                                                        <td>{item.program_names}</td>
                                                                        <td>{formattedSentDate}</td>
                                                                        <td>{formattedDeliveredDate}</td>
                                                                    </tr>
                                                                ) : (
                                                                    <>
                                                                        {" "}
                                                                        {modalTitle &&
                                                                            modalTitle ==
                                                                            "Fully Onboarded Patients" ? (
                                                                            <tr key={`two_${index}`}>
                                                                                <th
                                                                                    scope="row"
                                                                                    className="text-start ps-2"
                                                                                >
                                                                                    {item.patient_name}
                                                                                </th>
                                                                                <td>{item.nhsNumber}</td>
                                                                                <td>{item.mobile}</td>
                                                                                <td>{item.program_names}</td>
                                                                                <td>{formattedSentDate}</td>
                                                                                <td>{formattedDeliveredDate}</td>
                                                                                <td>{formattedLoginDate}</td>
                                                                                <td>{formattedOnboardingDate}</td>
                                                                            </tr>
                                                                        ) : (
                                                                            <>
                                                                                {" "}
                                                                                {modalTitle &&
                                                                                    modalTitle == "Accounts Created" ? (
                                                                                    <tr key={`three_${index}`}>
                                                                                        <th
                                                                                            scope="row"
                                                                                            className="text-start ps-2"
                                                                                        >
                                                                                            {item.patient_name}
                                                                                        </th>
                                                                                        <td>{item.nhsNumber}</td>
                                                                                        <td>{item.mobile}</td>
                                                                                        <td>{item.program_names}</td>
                                                                                        <td>{formattedSentDate}</td>
                                                                                        <td>{formattedDeliveredDate}</td>
                                                                                    </tr>
                                                                                ) : (
                                                                                    <>
                                                                                        {" "}
                                                                                        {modalTitle &&
                                                                                            (modalTitle ==
                                                                                            "In-Active Patients" || modalTitle =="Opt-Out Patients") ? (
                                                                                            <tr key={`four_${index}`}>
                                                                                                <th
                                                                                                    scope="row"
                                                                                                    className="text-start ps-2"
                                                                                                >
                                                                                                    {item.patient_name}
                                                                                                </th>
                                                                                                <td>{item.nhsNumber}</td>
                                                                                                <td>{item.mobile}</td>
                                                                                                <td>{item.program_names}</td>
                                                                                                <td>{formattedSentDate}</td>
                                                                                                <td>
                                                                                                    {formattedDeliveredDate}
                                                                                                </td>
                                                                                                <td>
                                                                                                    {formattedOnboardingDate}
                                                                                                </td>
                                                                                            </tr>
                                                                                        ) : (
                                                                                            <>
                                                                                                {modalTitle &&
                                                                                                    modalTitle ==
                                                                                                    "Partially Registered Patients" ? (
                                                                                                    <tr key={`five_${index}`}>
                                                                                                        <th
                                                                                                            scope="row"
                                                                                                            className="text-start ps-2"
                                                                                                        >
                                                                                                            {item.patient_name}
                                                                                                        </th>
                                                                                                        <td>{item.nhsNumber}</td>
                                                                                                        <td>{item.mobile}</td>
                                                                                                        <td>
                                                                                                            {item.program_names}
                                                                                                        </td>
                                                                                                        <td>
                                                                                                            {formattedSentDate}
                                                                                                        </td>
                                                                                                        <td>
                                                                                                            {formattedDeliveredDate}
                                                                                                        </td>
                                                                                                        <td>
                                                                                                            {formattedLoginDate}
                                                                                                        </td>
                                                                                                    </tr>
                                                                                                ) : (
                                                                                                    <>
                                                                                                        {modalTitle &&
                                                                                                            modalTitle ==
                                                                                                            "Scheduled In-Clinic Appointments" ? (
                                                                                                            <tr key={`six_${index}`}>
                                                                                                                <th
                                                                                                                    scope="row"
                                                                                                                    className="text-start ps-2"
                                                                                                                >
                                                                                                                    {item.patient_name}
                                                                                                                </th>
                                                                                                                {/* <td>
                                                                {item.nhsNumber}
                                                              </td>
                                                              <td>{item.mobile}</td> */}
                                                                                                                <td>
                                                                                                                    {
                                                                                                                        formattedScheduledDate
                                                                                                                    }
                                                                                                                </td>
                                                                                                                <td>
                                                                                                                    {
                                                                                                                        formattedScheduledDate
                                                                                                                    }
                                                                                                                </td>
                                                                                                                <td>
                                                                                                                    {
                                                                                                                        item.appointment_status
                                                                                                                    }
                                                                                                                </td>
                                                                                                            </tr>
                                                                                                        ) : (
                                                                                                            <>
                                                                                                                {modalTitle &&
                                                                                                                    modalTitle ==
                                                                                                                    "Completed In-Clinic Appointments" ? (
                                                                                                                    <tr key={`seven_${index}`}>
                                                                                                                        <th
                                                                                                                            scope="row"
                                                                                                                            className="text-start ps-2"
                                                                                                                        >
                                                                                                                            {
                                                                                                                                item.patient_name
                                                                                                                            }
                                                                                                                        </th>
                                                                                                                        {/* <td>
                                                                    {item.nhsNumber}
                                                                  </td>
                                                                  <td>
                                                                    {item.mobile}
                                                                  </td> */}
                                                                                                                        <td>
                                                                                                                            {
                                                                                                                                formattedScheduledDate
                                                                                                                            }
                                                                                                                        </td>
                                                                                                                        <td>
                                                                                                                            {
                                                                                                                                formattedScheduledDate
                                                                                                                            }
                                                                                                                        </td>
                                                                                                                        <td>
                                                                                                                            {
                                                                                                                                item.appointment_status
                                                                                                                            }
                                                                                                                        </td>
                                                                                                                        <td>
                                                                                                                            {
                                                                                                                                formattedCompletedDate
                                                                                                                            }
                                                                                                                        </td>
                                                                                                                    </tr>
                                                                                                                ) : (
                                                                                                                    <tr key={`eight_${index}`}>
                                                                                                                        <th
                                                                                                                            scope="row"
                                                                                                                            className="text-start ps-2"
                                                                                                                        >
                                                                                                                            {item.yearCount}
                                                                                                                        </th>
                                                                                                                        <td>
                                                                                                                            {item.monthCount ||
                                                                                                                                item.weekCount ||
                                                                                                                                item.Date}
                                                                                                                        </td>
                                                                                                                        <td>
                                                                                                                            {
                                                                                                                                item.total_conversations
                                                                                                                            }
                                                                                                                        </td>
                                                                                                                    </tr>
                                                                                                                )}
                                                                                                            </>
                                                                                                        )}
                                                                                                    </>
                                                                                                )}
                                                                                            </>
                                                                                        )}
                                                                                    </>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </>
                                                                )}
                                                            </>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan="6" className="text-center">
                                                            No data available
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* Pagination Controls */}
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <button
                                            className="btn btn-primary"
                                            onClick={handlePrevious}
                                            disabled={currentPage === 1}
                                        >
                                            Previous
                                        </button>
                                        <span>
                                            Page{" "}
                                            {modalContent && modalContent.length > 5
                                                ? currentPage
                                                : 0}{" "}
                                            of {totalPages ? totalPages : 0}
                                        </span>
                                        <button
                                            className="btn btn-primary"
                                            onClick={handleNext}
                                            disabled={currentPage === totalPages}
                                        >
                                            Next
                                        </button>
                                    </div>
                                    <div className="mt-3 text-end">
                                        {showExportButton && (
                                            <button
                                                className="btn btn-success me-2"
                                                onClick={fetchExportData}
                                                disabled={loadingExport}
                                            >
                                                {loadingExport
                                                    ? "Exporting..."
                                                    : "Prepare Data to Download"}
                                            </button>
                                        )}
                                        {csvData.length > 0 && (
                                            <CSVLink
                                                headers={headers}
                                                data={csvData}
                                                filename={`${modalTitle
                                                    .replace(/\s+/g, "_")
                                                    .toLowerCase()}.csv`}
                                                className="btn btn-success"
                                                disabled={loadingExport}
                                            >
                                                Export to CSV
                                            </CSVLink>
                                        )}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
})